<template>
    <div class="slide">
        <CategoryMenu :category="{ name: 'Type de contributeurs' }" class="category--filter">
            <span
                slot="title"
                class="color-pill"
                :class="{ active: value.vigilance && value.vigilance.id }"
            />
            <Select
                class="stretch filter"
                placeholder="Choisissez un type de contributeur"
                :options="vigilances"
                :value="value.vigilance"
                @input="updateVigilance"
            />
        </CategoryMenu>
        <CategoryMenu :category="{ name: 'Contributeurs' }" class="category--filter">
            <span
                slot="title"
                class="color-pill"
                :class="{ active: value.contributors && value.contributors.length }"
            />
            <Select
                class="stretch filter selection--item"
                placeholder="Rechercher"
                :options="contributors"
                :multiple="true"
                :search="true"
                :limit="100000"
                :value="value.contributors"
                @input="updateContributors"
            />
        </CategoryMenu>
    </div>
</template>

<script>
import CategoryMenu from '@/components/CategoryMenu';
import Select from '@/components/Select';

export default {
    props: {
        value: Object,
        vigilances: Array,
        contributors: Array,
    },
    methods: {
        updateVigilance: function(vigilance) {
            this.$emit('input', {
                ...this.value,
                vigilance,
            });
        },
        updateContributors: function(contributors) {
            this.$emit('input', {
                ...this.value,
                contributors,
            });
        },
    },
    components: {
        CategoryMenu,
        Select,
    },
};
</script>

<style lang="scss">
.category--filter {
    .category-title-button {
        padding: 8px 18px 8px 20px;
        background-color: #f6f7f8;

        &:hover {
            background-color: #ebedef;
        }
    }

    span {
        // vertical-align: middle;

        &.color-pill {
            border-radius: 50%;
            width: 11px;
            height: 11px;
            align-self: center;
            display: inline-block;
            margin-right: 9px;
            border: 1px solid #9ca5b0;

            &.active {
                border: 1px solid #93c11f;
                background-color: #93c11f;
            }
        }
    }

    .filter {
        padding: 20px 20px 19px 20px;

        .dropdown-toggle {
            margin: 8px 17px;
        }
    }

    .selection--item .dropdown-selection--item {
        border: none;
    }
}
</style>
